<template>
  <v-container id="forgot" class="fill-height" tag="section">
    <v-row justify="center">
      <v-form @submit.prevent="sendMail()">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  {{ $t("Forgot password") }}
                </h1>
              </div>
            </template>

            <v-card-text class="text-center">
              <v-text-field
                color="secondary"
                label="Email..."
                name="email"
                prepend-icon="mdi-email"
                v-model="email"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
              />
              <pages-btn
                large
                color=""
                depressed
                class="v-btn--text success--text"
                type="submit"
              >
                {{ $t("Reset Password") }}
              </pages-btn>
            </v-card-text>
            <a @click="$router.push({ name: 'auth.login' })">
              {{ $t("Login") }}
            </a>
          </base-material-card>
        </v-slide-y-transition>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
import { sendResetMail } from "./shared/services";

export default {
  name: "forgot",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    PagesBtn: () =>
      import("@/app/shared/components/template/pages/components/Btn")
  },
  data() {
    return {
      email: null
    };
  },
  methods: {
    sendMail() {
      if (this.email) {
        sendResetMail(
          {
            email: this.email
          },
          this.$validator
        )
          .then(resp => {
            if (resp.message) {
              this.$root.$notification(this.$t(resp.message[0]), {
                type: "success"
              });
            }
            this.$router.push({ name: "auth.login" });
          })
          .catch(resp => {
            this.$root.$notification(resp.message, { color: "error" });
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
